<nav class="navbar navbar-expand-lg navbar-primary bg-primary flex-row-reverse">
  <div ngbDropdown class="d-inline-block" [display]="responsiveService.isMobile ? 'static' : 'dynamic'" placement="bottom-right" *ngIf="!userInSession">
    <a class="btn btn-link text-white nav-link text-uppercase barra-separadora" id="dropdownFormLogin" ngbDropdownToggle>Login</a>
    <div ngbDropdownMenu aria-labelledby="dropdownFormLogin" [style.width.vw]="responsiveService.isMobile ? 100 : 35">
      <app-login [isPage]="false"></app-login>
    </div>
  </div>
  <div ngbDropdown class="d-inline-block" [display]="responsiveService.isMobile ? 'static' : 'dynamic'" placement="bottom-right" *ngIf="userInSession">
    <a class="btn btn-link text-white nav-link text-uppercase barra-separadora" id="dropdownFormSesion" ngbDropdownToggle>{{userName}}
      <svg class="bi" width="20" height="18" fill="currentColor">
        <use xlink:href="assets/img/user.svg#plus-circle" />
      </svg>
    </a>
    <div ngbDropdownMenu aria-labelledby="dropdownFormSesion" [style.width.vw]="5">
      <button (click)="openForm()" class="btn form-control text-uppercase">Cambiar clave</button>
      <hr>
      <button (click)="closeSession()" class="btn form-control text-uppercase">Cerrar Sesión</button>
    </div>
  </div>
  <div ngbDropdown class="d-inline-block" [display]="responsiveService.isMobile ? 'static' : 'dynamic'" placement="bottom-right" (openChange)="resetForm();">
    <a class="btn btn-link text-white nav-link text-uppercase" id="dropdownForm1" ngbDropdownToggle>Contacto</a>
    <div ngbDropdownMenu aria-labelledby="dropdownForm1" [style.width.vw]="responsiveService.isMobile ? 100 : 35">
      <form class="px-4 py-3 text-center" autocomplete="off" [formGroup]="form" (ngSubmit)="guardar()">
        <h3>Cbb Store Contacto</h3>
        <div class="form-group mb-3">
          <input type="text" class="form-control" formControlName="name" placeholder="Nombre"
            [class.is-invalid]="form.get('name')?.touched && form.get('name')?.invalid">
        </div>
        <div class="form-group mb-3">
          <input type="email" class="form-control" formControlName="email" placeholder="Email"
            [class.is-invalid]="form.get('email')?.touched && form.get('email')?.invalid">
        </div>
        <div class="form-group mb-3">
          <input type="text" class="form-control" formControlName="phone" placeholder="Teléfono"
            [class.is-invalid]="form.get('phone')?.touched && form.get('phone')?.invalid">
        </div>
        <div class="form-group mb-3">
          <select class="form-control" formControlName="region"
            [class.is-invalid]="form.get('region')?.touched && form.get('region')?.invalid">
            <option value="" selected disabled>Región</option>
            <option value="{{item.nombreRegion}}" *ngFor="let item of regionesComunas">
              {{item.nombreRegion}}</option>
          </select>
        </div>
        <div class="form-group mb-3">
          <select class="form-control" formControlName="comuna"
            [class.is-invalid]="form.get('comuna')?.touched && form.get('comuna')?.invalid">
            <option value="" selected disabled>Comuna</option>
            <option value="{{item}}" *ngFor="let item of comunaByRegion">{{item}}</option>
          </select>
        </div>
        <div class="form-group mb-3">
          <textarea class="form-control" formControlName="question" placeholder="Su Consulta" rows="4"
            [class.is-invalid]="form.get('question')?.touched && form.get('question')?.invalid">
                      ></textarea>
        </div>
        <button type="submit" class="btn btn-primary bg-secondary">Enviar</button>
      </form>
    </div>
  </div>
  <!-- <div ngbDropdown class="d-inline-block" display="dynamic" placement="bottom-right">
    <a class="btn btn-link text-white nav-link text-uppercase" href="https://compra.cbbstore.cl">Conoce más</a>
  </div> -->
</nav>
<div *ngIf="showFreeFrontLogo" class="free-front-logo-box">
  <a routerLink="/" class="nav-link free-front-logo-link">
    <img src="assets/img/logo.svg" alt="Cbb Store" class="free-front-logo-main" />
  </a>
</div>
<div *ngIf="!isFreeFrontPage" class="container-fluid bg-transparent m-1 pb-1" style="padding-top: 2.5rem !important">
  <div [class]="responsiveService.styleResponsive('d-flex px-1', 'd-flex px-5') | async">
    <a routerLink="/" class="nav-link" [class]="responsiveService.styleResponsive('ps-3', '') | async">
      <img src="assets/img/logo.svg" alt="Cbb Store"
          [width]="responsiveService.styleResponsive('100', '150') | async">
    </a>
    <h5 *ngIf="!isFreeFrontPage"
        [class]="responsiveService.styleResponsive('m-auto', 'm-5 my-auto') | async"
        style="color: gray;"
        [style.font-size]="responsiveService.isMobile ? '5vw' : '1.7vw'">
      Compra <strong style="color: black;">online</strong> en simples pasos.
      Despachamos directo a <strong style="color: black;">tu obra</strong>.
    </h5>
  </div>
</div>
<app-step *ngIf="!isFreeFrontPage"></app-step>
<ngx-invisible-recaptcha #captchaElem siteKey="siteKey" badge="'bottomright'" useGlobalDomain="false"
  [(ngModel)]="recaptcha" [ngModelOptions]="{ standalone: true }">
</ngx-invisible-recaptcha>
<router-outlet [class]="isFreeFrontPage ? '' : 'container'"></router-outlet>
<app-footer class="footer mt-auto"></app-footer>

<a *ngIf="commercialAssistantHref"
   class="commercial-assistant"
   [href]="commercialAssistantHref"
   target="_blank"
   rel="noopener noreferrer"
   aria-label="Contactar al Asistente Comercial Virtual por WhatsApp (abre una nueva pestaña)">
  <span>Asistente Comercial Virtual</span>
  <svg class="commercial-assistant-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
    <path d="M20.52 3.48A11.9 11.9 0 0 0 12.06 0C5.5 0 .16 5.34.16 11.9c0 2.1.55 4.15 1.59 5.96L.06 24l6.29-1.65a11.9 11.9 0 0 0 5.69 1.45h.01c6.56 0 11.9-5.34 11.9-11.9 0-3.18-1.24-6.16-3.43-8.42ZM12.05 21.8a9.9 9.9 0 0 1-5.04-1.38l-.36-.21-3.73.98 1-3.64-.24-.38a9.88 9.88 0 0 1-1.52-5.27c0-5.46 4.44-9.9 9.9-9.9a9.84 9.84 0 0 1 7 2.9 9.84 9.84 0 0 1 2.9 7c0 5.46-4.44 9.9-9.91 9.9Zm5.43-7.41c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.76-1.66-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.87 1.21 3.07c.15.2 2.1 3.2 5.09 4.49.71.3 1.26.48 1.69.61.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2-1.41.25-.7.25-1.29.18-1.41-.08-.13-.28-.2-.58-.35Z" />
  </svg>
</a>





<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Cambiar Contraseña</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <form autocomplete="off" [formGroup]="form_psw" (ngSubmit)="update()">
    <div class="modal-body">
      <input type="text" placeholder="Clave *" [style.border]="'1.5px solid lightgray'" [style.font-size.px]="22"
        class="w-100 mt-3 pt-3 pb-1 px-3 form-control rounded-0" formControlName="password"
        [class.is-invalid]="form_psw.get('password')?.touched && form_psw.get('password')?.invalid"
        aria-describedby="firstnameValidation" />

      <input type="text" placeholder="Nueva Clave *" [style.border]="'1.5px solid lightgray'" [style.font-size.px]="22"
        class="w-100 mt-3 pt-3 pb-1 px-3 form-control rounded-0" formControlName="new_password_1"
        [class.is-invalid]="form_psw.get('new_password_1')?.touched && form_psw.get('new_password_1')?.invalid"
        aria-describedby="new_password_1Validation" />
      <input type="text" placeholder="Repetir Clave *" [style.border]="'1.5px solid lightgray'"
        [style.font-size.px]="22" class="w-100 mt-3 pt-3 pb-1 px-3 form-control rounded-0"
        formControlName="new_password_2"
        [class.is-invalid]="form_psw.get('new_password_2')?.touched && form_psw.get('new_password_2')?.invalid"
        aria-describedby="new_password_2Validation" />


    </div>
    <p class="text-danger text-center">{{message}}</p>
    <div class="modal-footer">

      <button type="submit" class="btn btn-success text-uppercase">Cambiar</button>
    </div>
  </form>
</ng-template>
